(function () {
  let openPanel = null;
  let openTrigger = null;

  function bindRipple(button, rippleSelector, clickedClass) {
    const ripple = button.querySelector(rippleSelector);
    if (!ripple) return;

    button.addEventListener('pointerdown', (event) => {
      const rect = button.getBoundingClientRect();
      const prefix = rippleSelector === '.lcb-ripple' ? 'lcb' : 'cb';
      ripple.style.setProperty(`--${prefix}-ripple-x`, `${event.clientX - rect.left}px`);
      ripple.style.setProperty(`--${prefix}-ripple-y`, `${event.clientY - rect.top}px`);
      button.classList.remove(clickedClass);
      void button.offsetWidth;
      button.classList.add(clickedClass);
    });

    ripple.addEventListener('animationend', () => {
      button.classList.remove(clickedClass);
    });
  }

  function closePanel(panel, trigger) {
    if (!panel || !trigger) return;
    panel.classList.remove('is-open');
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    if (openPanel === panel) {
      openPanel = null;
      openTrigger = null;
    }
  }

  function openPanelForTrigger(panel, trigger) {
    if (openPanel && openPanel !== panel && openTrigger) {
      closePanel(openPanel, openTrigger);
    }

    panel.hidden = false;
    panel.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    openPanel = panel;
    openTrigger = trigger;
  }

  document.querySelectorAll('.floating-action--mobile .lcb-button').forEach((button) => {
    bindRipple(button, '.lcb-ripple', 'lcb-is-clicked');
  });

  document.querySelectorAll('.floating-action--desktop .cb-contact-button').forEach((button) => {
    bindRipple(button, '.cb-ripple', 'cb-is-clicked');
  });

  document.querySelectorAll('[data-floating-action-trigger]').forEach((trigger) => {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      const isOpen = panel.classList.contains('is-open');

      if (isOpen) {
        closePanel(panel, trigger);
      } else {
        openPanelForTrigger(panel, trigger);
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (!openPanel || !openTrigger) return;
    if (openPanel.contains(event.target) || openTrigger.contains(event.target)) return;
    closePanel(openPanel, openTrigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !openPanel || !openTrigger) return;
    closePanel(openPanel, openTrigger);
    openTrigger.focus();
  });
})();
